module.exports = __webpack_public_path__ + "img/menucn_2_1.0dca6884.svg";